import { AssetfiAssetType } from '@/types/asset-type';

export default function LayersSvg({ width = 24, height = 24 }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 8L12 4L20 8L12 12L4 8Z" stroke="#242424" strokeWidth="2" strokeLinejoin="round" />
      <path d="M4 12L12 16L20 12" stroke="#242424" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 16L12 20L20 16" stroke="#242424" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
